<section id="info-principal" class='row' *ngFor="let item of ocorrencias">
  <article> <div> IC % de Reversão: <span> {{ item.ic_reversao }}% </span></div> </article> 
  <article> <div> Dev. Parcial: <span> {{ item.dev_parcial }} </span></div> </article>
  <article> <div> Reentrega: <span> {{ item.reentrega }} </span></div> </article>
  <article> <div> Reversão: <span> {{ item.reversao }} </span></div> </article>
  <article> <div> Total de Ocorrências: <span> {{ item.total_ocorrencias }} </span></div> </article>
  <article> <div> Tempo médio de retorno: <span> {{ item.tempo_medio_retorno }} </span></div> </article>            
</section>